module.exports = "mutation removeFavorite($productId:String!){removeFavorite(productId:$productId)}"